// import ScrollTrigger from '@terwanerik/scrolltrigger';
import { ajax } from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import easing from 'jquery.easing';
import Swiper from 'swiper';
import swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';


// import Cookies from 'js-cookie';

// import lightcase from "lightcase";
// import 'lightcase/src/css/lightcase.css';


export class App {
  constructor(){
    this.html = document.documentElement;
    this.body = document.body;
    this.page = document.getElementById('page');
    this.main = document.querySelector('.site-main');
    this.header = document.getElementById('site-header');
		// this.header_inner = this.header.querySelector('.site-header__inner');
		// this.header_txtContainer = this.header.querySelector('.header_pc');
    // this.logo = document.getElementById('logo');
    // this.navWrap = document.querySelector('.navWrap');
    // this.gnav = document.querySelector('.gnav');
    // const g_ul = this.gnav.querySelector('.gnav')
    // g_ul.classList.remove('gnav')
    // this.snav = document.getElementById('snav');
    
    // this.gnavContainer = document.querySelector('.gnavContainer');
    // this.has_ch = this.gnav.querySelectorAll('.has_ch');

    // this.winW = window.innerWidth;
    // this.winH = window.innerHeight;
    // this.headerH = this.header.offsetHeight;
    // this.logoH = this.logo.offsetHeight;
    // this.logoW = this.logo.offsetWidth;
    // this.w_items = document.querySelectorAll('.postList-item');

    // this.menuOpen = false;
    // this.btn_pagetop = document.getElementById('btn_pagetop');
    // this.ua = ua;
    this.sp = 700;
    // this.ease = "easeInOutExpo";

    // gsap.registerPlugin(ScrollTrigger)
  }

  wrapCharSpan(strs){
    return [...strs].map( tx => `<span>${tx}</span>`).join('');
  }
  
  init(){
    console.log('init');

    // return;

    
    this.judge(); //is frontpage
    
  //   if(this.has_ch){
  //   this.has_ch.forEach(
  //     _ch => {
  //       const _wrap = _ch.querySelector('.catListWrap');
  //       const _list = _ch.querySelector('.catList');
  //       _ch.addEventListener('mouseover', (e) => {
  //         _wrap.style.maxHeight = _list.offsetHeight + "px";
  //       })
  //       _ch.addEventListener('mouseout', (e) => {
  //         _wrap.style.maxHeight = 0;
  //       })
  //     }
  //   )
  // }

    if(this.is_frontpage){

      // if(this.ua === "mobile" && !map_disable){
      // }
    }else{
      
    }




    window.addEventListener('load', (e) => {
      console.log('load')
      $('.spinner').fadeOut('slow',function(){
        $(this).remove();
      });
      this.body.classList.add('loaded');
      this.page.classList.add('on');
      // this.main.classList.add('on');

      

      if(this.body.classList.contains('home')){ 

      }
      

			// this.makeSp();

      this.resize();

      this.events();

      this.makeGsap();

      // this.trigger();

      const hash = window.location.hash;
      if(hash){
        const target = document.getElementById(hash.replace('#',''))
        if(target){
          // console.log(target)
          setTimeout((e) => {
            this.anim(target)
          },200);
        }
      }

    });


    //  document.addEventListener("DOMContentLoaded", function() {
    // const hash = window.location.hash;
    // console.log('DOMContentLoaded')
    // if (hash) {
    //   // ページロード後にスムーススクロールで目的地へ
    //   const target = document.querySelector(hash);
    //   // console.log(target)
    //   if (target) {
    //     // 少し遅らせてスクロール（画像などの読み込み対策）
    //     setTimeout(() => {
    //       target.scrollIntoView({
    //         behavior: "smooth",
    //         block: "start"
    //       });
    //     }, 700);
    //   }
    // }
  // });

    
  }







  // buildMap(_id, marker_data, options_data, state){
  //   this.gmap = new GmapCtrl(_id, marker_data, options_data, state, this.ua);
  // }

  queryMatch(jud){
    // console.log(jud);
    if(jud === 'sp'){

    }else{
      
      // console.log(this.menuOpen);
    }
  }

  makeGsap(){
    const scT = document.querySelectorAll('.sct')
    const scO = document.querySelectorAll('.sco')
    const scR = document.querySelectorAll('.scr')
    const paras = document.querySelectorAll('.para')
    const paras2 = document.querySelectorAll('.para2')
    const paras3 = document.querySelectorAll('.para3')

    scO.forEach(
      _sco => {
        gsap.fromTo(_sco, {
          opacity:0
        },{
          opacity:1,
          duration: 1.0,
          scrollTrigger: {
            trigger:_sco,
            start: "top bottom-=20%"
          }
        })
      }
    )

    scT.forEach(
      _sct => {
        gsap.fromTo(_sct, {
          y: "40px",
          opacity: 0
        }, {
          y:"0",
          opacity:1,
          duration: .7,
          scrollTrigger: {
            trigger: _sct,
            start: "top bottom-=20%"
          }
        })
      }
    )
    
    scR.forEach(
      _scr => {
        gsap.fromTo(_scr, {
          x: "15%",
          opacity: 0
        }, {
          x:"0",
          opacity:1,
          duration: .7,
          scrollTrigger: {
            trigger: _scr,
            start: "top bottom-=15%"
          }
        })
      }
    )

    paras.forEach(
      _para => {
        gsap.fromTo(_para, {
          y: "0"
        }, {
          y:"15%",
          ease: "none",
          scrollTrigger: {
            trigger: _para,
            start: "top top",
            end: "bottom top",
            scrub: 1.2
          }
        })
      }
    )
    
    paras2.forEach(
      _para => {
        gsap.fromTo(_para, {
          y: "0"
        }, {
          y:"30%",
          ease: "none",
          scrollTrigger: {
            trigger: _para,
            start: "top top",
            end: "bottom top",
            scrub: 1.2
          }
        })
      }
    )
    
    paras3.forEach(
      _para => {
        gsap.fromTo(_para, {
          y: "-30%"
        }, {
          y:"0",
          ease: "none",
          scrollTrigger: {
            trigger: _para,
            start: "top bottom",
            end: "bottom top",
            scrub: .5
          }
        })
      }
    )

  }
  


  events(){
    window.addEventListener('scroll', (e) => { this.scroll(); });
    window.addEventListener('resize',(e)=>{this.resize();});



    if(document.querySelectorAll('.catList').length){
      const catList = document.querySelectorAll('.catList');
      catList.forEach(
        _list => {
          const _dts = _list.querySelectorAll('dt')
          _dts.forEach(
            _dt => {
              
              _dt.addEventListener('click', (e) => {
                const _box = _dt.parentNode
                _box.classList.toggle('open')
                // _dt.classList.toggle('open')
                // const _ddH = _dt.nextElementSibling.querySelector('.catList__children').offsetHeight
                
              })
            }
          )
        }
      )
    }

    //header
    const hmMenuContainer = document.querySelector('.hmMenuContainer')
    const btn_hm = document.getElementById('btn_hm')
    const menu_back = document.querySelector('.hmMenuContainer-back')
    // console.log(btn_hm)
    let btn_state = false;

    btn_hm.addEventListener('click', (e) => {
      btn_state = !btn_state
      changeBtn()
    })
    menu_back.addEventListener('click', () => {
      btn_state= false
      changeBtn()
    })

    const changeBtn = () => {
      if(btn_state){
        btn_hm.classList.remove('off')
        btn_hm.classList.add('on')
        hmMenuContainer.classList.add('on')
      }else{
        btn_hm.classList.remove('on')
        btn_hm.classList.add('off')
        hmMenuContainer.classList.remove('on')
      }
    }




    if(this.body.classList.contains('home_xxxxx')){
      
      this.swipers = document.querySelectorAll('.swp')
      if(this.swipers.length){
        this.swps = [];
        let swObj = {
          speed: 1000,
          loop: true,
          effect: 'fade',
          allowTouchMove: true,
          slidesPerView:1,
          autoplay:{
            delay:5000,disableOnInteraction:false
          }
        }

        let sw_cnt = 1
        this.swipers.forEach(
          swp => {
            swp.classList.add(`sw${sw_cnt}`)
            const sl_len = swp.querySelectorAll('.swiper .swiper-slide').length;
            if(sl_len == 1){
              swObj.loop = false;
              swObj.autoplay = false;
            }
            const _name = `sw${sw_cnt}`

            const _swp = new Swiper(`.sw${sw_cnt}`, swObj)
            this.swps[_name] = _swp
            // console.log(_swp)

            sw_cnt++;
          }
        )
      }
    }
    if(this.body.classList.contains('contact')){
      const labels = document.querySelectorAll('.smf-item')
      labels.forEach(
        _label => {
          _label.classList.add('u_d_fl')
          _label.classList.add('_rs')
          if(_label.classList.contains('require')){
            const lb = _label.querySelector('.smf-item__label')
            const add = document.createElement('span');
            add.classList.add('req_txt');
            add.innerHTML = `(<span class="">*</span class="txt">必須<span></span>)`;
            lb.appendChild(add)
          }

        }
      )
    }
    if(this.body.classList.contains('works')){
      const _secs = document.querySelectorAll('.sec');
      _secs.forEach(
        _sec => {
          const sec_head = _sec.querySelector('.sec__header');
          const dataContainer = _sec.querySelector('.dataContainer')
          const dataContainer_column = _sec.querySelector('.dataContainer__column')

          const _btn = document.createElement('div');
          _btn.innerHTML = `<div class="btnSec__inner"><span class="bar"></span><span class="bar"></span></div>`;
          _btn.classList.add('btnSec');
          sec_head.appendChild(_btn)

          sec_head.addEventListener('click', (e) => {
            // console.log('click')
            if(_sec.classList.contains('on')){
              _sec.classList.remove('on')
              dataContainer.style.maxHeight = 0
            }else{
              _sec.classList.add('on')
              const mxh = dataContainer_column.offsetHeight
              // console.log(mxh)
              dataContainer.style.maxHeight = mxh+"px"
            }
          });
        }
      )
    }


    // if(typeof this.btn_sp != 'undefined' ){
    //   this.btn_sp.addEventListener('click',(e) => {
    //     // console.log('sp');
    //     if(this.header.classList.contains('on')){
    //       this.menuOff();
    //     }else{
    //       this.menuOn();
    //     }
    //   });
    // }

   
    const atags = document.querySelectorAll("a[href^='#']");
    // console.log(atags);
    this.pageLink(atags);

    this.bet = 0;
    const options = {
      root:null,
      rootMargin:`${this.bet}px`,
      threshold: 0.1
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(
        entry => {
          // console.log(entry.isIntersecting);
          // if(entry.isIntersecting){
          //   this.btnWrap.classList.remove('on');
          // }else{
          //   this.btnWrap.classList.add('on');
          // }
        //  if(entry.target.classList.contains('headerContainer')){
        //   // console.log(entry.intersectionRatio);
        //   if(entry.intersectionRatio < 0.1 ){
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.add('on');
        //   }else{
        //     // console.log(entry.intersectionRatio);
        //     // this.btn_pagetop.classList.remove('on');
        //   }
        //  }

        }
      )
    }, options);

    //if(this.ua !== "mobile"){
      // this.ov_ttl = document.querySelector('.site-title');
      // observer.observe(this.ov_ttl);
    //}

				// this.btn_sp.addEventListener('click',(e) => {
    //     // console.log('sp');
    //     if(this.header.classList.contains('on')){
    //       this.menuOff();
    //     }else{
    //       this.menuOn();
    //     }
    //   });
      // this.menu_back.addEventListener('click', (e) => {
      //   this.menuOff();
      // });
      if(this.body.classList.contains('home') || this.body.classList.contains('archive')){
        
      }
    if(!this.body.classList.contains('home')){
      

      
    }else{// home
      // if(this.ua === "mobile"){
      //   const _secContainer = document.querySelector('.headerContainer');
      //   // observer.observe(_secContainer);
      // }
      // // console.log(observer);
      // const bnr_donation = document.getElementById('bnr_donation');
      // if(bnr_donation){
      // const sec_proc = document.querySelector('.sec-process');
      // // console.log(bnr_donation);
      // sec_proc.appendChild(bnr_donation);
      // bnr_donation.outerHTML = `<div class='bnrContainer mx-sp-500'>${bnr_donation.outerHTML}</div>`;
      // }

    }


    

    // if(this.body.classList.contains('contact')){
    //   const _form = document.querySelector('div[id ^= "mw_wp_form_mw-wp-form-"]');
    //   if(_form.classList.contains('mw_wp_form_input')){
    //     const _check = document.querySelector('input[type=checkbox]');
    //     const _btnContainer = document.getElementById('btnContainer');
    //     if(_check.checked){ _btnContainer.classList.add('on');}
        
    //     _check.addEventListener('click',(e)=>{
    //       if(e.currentTarget.checked){
    //         _btnContainer.classList.add('on');
    //       }else{
    //         _btnContainer.classList.remove('on');
    //       }
    //     });
    //   }
    // }

    // if(this.body.classList.contains('single') || 
    // this.body.classList.contains('page')){
    //   $('a[data-rel^=lightcase]').lightcase({
    //     maxHeight:2000,
    //     maxWidth:2000
    //   });
    // }

    
    


    const mediaQueryList = window.matchMedia('(min-width:897px)');
    const listener = (e) => {
      if(e.matches){
        this.queryMatch('pc');
        
      }else{
        this.queryMatch('sp');
      }
    }
    mediaQueryList.addEventListener('change', listener);

    listener(mediaQueryList);
    

  }

  itemShow(jud){
    if(jud){
      this.w_items.forEach(
        _item => {
          if(_item.classList.contains('regularly')){
            _item.classList.remove('off');
          }
        }
      )
    }else{
      this.w_items.forEach(
        _item => {
          if(_item.classList.contains('regularly')){
            _item.classList.add('off');
          }
        }
      )
    }
    
  }
  
  pageLink(atg){
    const _atags = atg;
    for (const _a of _atags) {
          // console.log(_a);
      _a.addEventListener('click', (e) => {
        e.preventDefault();
        let href = e.currentTarget.getAttribute('href');
        if (href == "#" || href == "") {
          href = "#page";
          this.sp = 1000;
        }
        href = href.replace("#", "");
        const target = document.getElementById(href);
        // setTimeout((e) => {
          this.anim(target);
        // }, 100);
      });
    }
  }

  judge(){
    if(this.body.classList.contains('home')){
      this.is_frontpage = true;
    }else{
      this.is_frontpage = false;
    }
  }

  makeSp(){


    this.btn_sp = document.createElement('div');
    this.btn_sp.classList.add('btnSp');
    this.btn_sp.classList.add('u_sp');
    // this.btn_sp.classList.add('sp');
    this.btn_sp.innerHTML = `<div class='btnSp-inner'>
    <span class="bar"></span><span class="bar"></span><span class="bar"></span>
    </div>`;
    // this.header_inner.insertBefore(this.btn_sp, this.header.firstElementChild);
    this.gnavContainer = document.createElement('div');
    this.gnavContainer.classList.add('gnavContainer')
    this.menu_back = document.createElement('div');
    this.menu_back.classList.add('gnav-back');
    this.gnavContainer.appendChild(this.menu_back);


    const gnav_sp = this.gnav.cloneNode(true);
    gnav_sp.setAttribute('class','');
    gnav_sp.classList.add('gnav_sp');
    gnav_sp.querySelector('ul').setAttribute('class','')
    gnav_sp.querySelector('ul').classList.add('gnavListSp');

    const _top = document.createElement('li');
    _top.classList.add('gnavListSp-item')
    _top.innerHTML = `<a href="/"><span class="wp-block-navigation-item__label">トップ</span></a>`

    gnav_sp.querySelector('ul').insertBefore(_top, gnav_sp.querySelector('ul').firstElementChild)
    this.gnavContainer.appendChild(gnav_sp);
    gnav_sp.querySelectorAll('li').forEach(
      _li => {
        _li.setAttribute('class','')
        _li.classList.add('gnavListSp-item')
        _li.querySelector('a').addEventListener('click', (e) => {
          this.menuOff();
        })
      }
    )
    

		this.header_txtContainer.append(this.gnavContainer);
		this.header_txtContainer.append(this.btn_sp);

    
    
    
    
    

    // this.btn_close = document.createElement('div');
    // this.btn_close.classList.add('btn_close');
    // this.btn_close.innerHTML = `<span class="bar"></span><span class="bar"></span>`;
    // this.gnavContainer.appendChild(this.btn_close);

    // this.btn_close.addEventListener('click', (e) => {
    //   this.menuOff();
    // });
    this.menu_back.addEventListener('click', (e) => {
      this.menuOff();
    });

    // this.gnav.querySelectorAll('.item-nav_cl a').forEach(
    //   _nav_cl => {
    //     _nav_cl.addEventListener('click', (e) => {
    //       // e.preventDefault();
    //       this.menuOff();
    //     });
    //   }
    // )

    this.btn_sp.addEventListener('click', (e) => {
      // console.log(this.header_txtContainer.classList.contains('on'));
      if(this.header.classList.contains('on')){
        this.menuOff();
      }else{
        this.menuOn();
      }
    });
  }
  menuOff(){
			// console.log('off');
    this.menuOpen = false;
    this.header.classList.remove('on');
    // this.btn_sp.querySelector('.bar:nth-child(1)').style.animationName = "bar1";
    // this.btn_sp.querySelector('.bar:nth-child(3)').style.animationName = "bar3";
  }
  menuOn(){
    // console.log('on')
    this.menuOpen = true;
    this.header.classList.add('on');
				// console.log(this.header.classList);
  }




  scroll(){
    if(!this.is_frontpage){
      // console.log(window.pageYOffset);
    }
  }
  resize(){
    this.get_size();


      this.html.style.setProperty('--hh', this.headerH+"px");
      // this.html.style.setProperty('--lgh', this.logoH+"px");
      // this.html.style.setProperty('--lgw', this.logoW+"px");
      if(this.map){
        this.html.style.setProperty('--ctr',this.mapControll.offsetHeight+"px");
      }


   
  }
  get_size(){
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;
    // this.logoH = this.logo.offsetHeight;
    // this.logoW = this.logo.offsetWidth;
    this.headerH = this.header.offsetHeight;
  }
  anim(_t,_tt=this.sp) {
    const rect = _t.getBoundingClientRect();
    const scT = window.pageYOffset || document.documentElement.scrollTop;
    let targetT  = rect.top;

    targetT = rect.top + scT - this.headerH;

    if(this.body.classList.contains('foo-xx')){
       // - this.headerH;
       targetT = rect.top + scT - this.headerH - this.catListContainer.offsetHeight;
      //  console.log(document.getElementById('catListContainer').offsetHeight);
    }
    console.log(_tt);
    $('html,body').animate({
      scrollTop: targetT
    }, _tt);
  }


  trigger(){
    this.trigger = new ScrollTrigger({
      trigger: {
        offset: {
          viewport: {
            x: 0,
            y: (trigger, rect, direction) => {
              return 0.1;
            }
          }
        },
        toggle: {
          callback: {
            in:(trigger)=>{
            },
            out:(trigger)=>{
            }
          }
        }
      }
    });
    this.trigger.add('[data-scroll]', {
      once: true,
      toggle: {
        class: {
          in: 'animIn',
          out: 'animOut'
        },
        callback: {
          in:(trigger) => {
            // if(trigger.element.classList.contains('img_circle')){
            //   setTimeout((e) => {
            //     console.log('beginElement');
            //     this.animate.beginElement();
            //     document.getElementById('img_circle').classList.add('on');
            //   },200);
            // }
          },
          out:(trigger) => {

          }
        }
      }
    })
  }
  
}
